if(Shopify.designMode != true){
  document.addEventListener("DOMContentLoaded", function(e) {
    if (window.theme.stickyHeader) {
      setTimeout(function(){
        //DOM refs
        const stickyWrapper = document.getElementById("sticky-form-wrapper");
        const stickyFormContainer = document.querySelector(".sticky-form-container");
        const navbarMain = document.querySelector(".header-bravo");
        const productContainer = document.querySelectorAll('#product-form');
        //heights of elements
        productContainer.forEach(function(item) {
          if(item != null){
            let productHeight = item.getBoundingClientRect().height;
            let stickyHeight = navbarMain.getBoundingClientRect().height;
            let stickyFormContainerHeight = stickyFormContainer.getBoundingClientRect().height;
            console.log('height of header', stickyHeight);
            console.log('height of product container', productHeight, (productHeight / 2).toString() + "px");
            //observer
            const stickyForm = function(entries) {
              const [entry] = entries;
              if(!entry.isIntersecting){
                stickyFormContainer.classList.add("sticky-form");
              }
              else {
                stickyFormContainer.classList.remove("sticky-form");
              }
            }
            const headerObserver = new IntersectionObserver(stickyForm, {
              root: null,
              threshold: 0,
              rootMargin: (productHeight).toString() + "px", // "px",
            });
            if(stickyWrapper != null) {
              headerObserver.observe(stickyWrapper);
            }
          }
        });
      }, 1000);
    }
  });
}
